import { render } from "./SideMenuComponent.vue?vue&type=template&id=1947f5c2&scoped=true"
import script from "./SideMenuComponent.vue?vue&type=script&lang=js"
export * from "./SideMenuComponent.vue?vue&type=script&lang=js"

import "./SideMenuComponent.vue?vue&type=style&index=0&id=1947f5c2&scoped=true&lang=css"

import exportComponent from "/home/u1042/tmp/bet-clipcut-003-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1947f5c2"]])

export default __exports__